import customZH from './zh.js';
import customTW from './tw.js';
import customEN from './en.js';
import vuex from '../store';
import { createI18n } from 'vue-i18n'

const messages = {
    en: {
        ...customEN,
    },
    zh: {
        ...customZH ,
    },
    tw: {
        ...customTW ,
    }
}



const getLanguage = () => {
    return vuex.state.lang;
}

console.log(getLanguage(), 'getLanguage')
const i18n = createI18n({
    locale: vuex.state.lang, // 设置默认语言为中文
    fallbackLocale: 'tw', // 当语言不存在时，使用默认语言
    globalInjection: true, // 全局注册 $t 函数
    legacy: false,
    messages
})

// 订阅 Vuex store 的变化
vuex.subscribe((mutation, state) => {
    // 假设你有一个名为 'setLanguage' 的 mutation 来更新 lang
    if (mutation.type === "setLang") {
        i18n.global.locale.value = state.lang; // 关键：同步更新 i18n 的 locale
    }
});

export default i18n;
